import { cn } from '@immo/ui-kit';

type Props = {
  /** done/total in [0, 1]. */
  readonly share: number;
  readonly stale: boolean;
  readonly label: string;
  readonly size?: 'sm' | 'md';
};

/** A command's done/total. A stale snapshot fills in warning, so a stuck run reads at a glance. */
export function RunProgressBar({ share, stale, label, size = 'sm' }: Props) {
  const percent = Math.round(share * 100);

  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      className={cn('overflow-hidden rounded-full bg-neutral-100', size === 'sm' ? 'h-1.5' : 'h-2')}
    >
      <div
        className={cn('h-full rounded-full', stale ? 'bg-warning-500' : 'bg-interactive')}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
